import React, { useState } from 'react';

const HelpButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => setIsOpen(!isOpen);

  const buttonStyle = {
    position: 'fixed',
    top: '1rem',
    right: '1rem',
    width: '2.5rem',
    height: '2.5rem',
    backgroundColor: '#E85C3E',
    color: 'white',
    border: 'none',
    borderRadius: '9999px',
    cursor: 'pointer',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    boxShadow: '0 1px 2px rgba(33, 29, 26, 0.08), 0 4px 12px rgba(33, 29, 26, 0.12)',
  };

  const popupStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(33, 29, 26, 0.45)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
    boxSizing: 'border-box',
  };

  const popupContentStyle = {
    backgroundColor: '#FBF7F1',
    padding: '2rem',
    borderRadius: '1.5rem',
    width: '440px',
    maxWidth: '100%',
    maxHeight: '80%',
    overflow: 'auto',
    boxShadow: '0 1px 2px rgba(33, 29, 26, 0.06), 0 12px 32px rgba(33, 29, 26, 0.16)',
    color: '#211D1A',
  };

  return (
    <>
      <button onClick={togglePopup} style={buttonStyle}>
        ?
      </button>
      {isOpen && (
        <div style={popupStyle} onClick={togglePopup}>
          <div style={popupContentStyle} onClick={(e) => e.stopPropagation()}>
            <h2 style={{ marginTop: 0, fontWeight: 800, fontSize: 20, letterSpacing: '-0.01em' }}>How To Play</h2>
            <p style={{ marginBottom: '1rem', color: '#4A443E', lineHeight: 1.5 }}>A word has been drawn on the circle by connecting each of its letters in order and
                filling in the overlapping space. Your task is to figure out what that solution word is! </p>
            <p style={{ marginBottom: 0, color: '#4A443E', lineHeight: 1.5 }}>Typing in letters will draw corresponding lines above to help check your work.</p>
          </div>
        </div>
      )}
    </>
  );
};

export default HelpButton;